import { render, staticRenderFns } from "./CGVConsult.vue?vue&type=template&id=60eb8dc8&scoped=true"
import script from "./CGVConsult.vue?vue&type=script&lang=js"
export * from "./CGVConsult.vue?vue&type=script&lang=js"
import style0 from "./CGVConsult.vue?vue&type=style&index=0&id=60eb8dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb8dc8",
  null
  
)

export default component.exports